import React, { useState, useEffect } from 'react';
import isElectron from 'is-electron';
import PropTypes from 'prop-types';
import { useIntl, FormattedMessage } from 'react-intl';

import CookieConsent from 'react-cookie-consent';

import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import ReactLoading from 'react-loading';

import { withStyles } from '@material-ui/core/styles';
import {
	Dialog,
	DialogContentText,
	DialogTitle as MuiDialogTitle,
	DialogContent as MuiDialogContent,
	DialogActions as MuiDialogActions
} from '@material-ui/core';

import {
	Grid,
	Typography,
	Button,
	TextField
} from '@material-ui/core';

import { wrapperAxios, getErrMesage } from '../utils';

import * as meActions from '../actions/meActions';
import * as roomActions from '../actions/roomActions';
import * as settingsActions from '../actions/settingsActions';

import edition from '../version';

import { withRoomContext } from '../RoomContext';
import Logger from '../Logger';

const logger = new Logger('LoginDialog');

const styles = (theme) => ({
	root:
	{
		display              : 'flex',
		width                : '100%',
		height               : '100%',
		backgroundColor      : 'var(--background-color)',
		backgroundImage      : `url(${window.app_base_path}/svg/background.svg)`,
		backgroundAttachment : 'fixed',
		backgroundPosition   : 'center',
		backgroundSize       : 'cover',
		backgroundRepeat     : 'no-repeat',
		alignItems           : 'center',
		justifyContent       : 'center'
	},
	dialogTitle:
	{
	},
	dialogRoot : {
		zIndex : 1300
	},
	dialogPaper:
	{
		width: '30vw',
		backgroundColor: '#fff',
		padding: theme.spacing(2),
		[theme.breakpoints.down('lg')]:
		{
			width: '40vw'
		},
		[theme.breakpoints.down('md')]:
		{
			width: '50vw'
		},
		[theme.breakpoints.down('sm')]:
		{
			width: '70vw'
		},
		[theme.breakpoints.down('xs')]:
		{
			width: '90vw'
		}
	},
	logo:
	{
		display: 'block',
		paddingBottom: '1vh'
	},
	loginButton:
	{
		position: 'absolute',
		right: theme.spacing(2),
		top: theme.spacing(2),
		padding: 0
	},
	largeAvatar:
	{
		width: 50,
		height: 50
	},
	green:
	{
		color: 'rgba(0, 153, 0, 1)'
	},
	red:
	{
		color: 'rgba(153, 0, 0, 1)'
	},
	version : {
		fontSize : '0.8rem'
	},
	locale : {
		'& .MuiOutlinedInput-input': {
			padding  : theme.spacing(1, 4, 1, 1.75),
			fontSize : '0.98rem'
		  }
	}

});

const DialogTitle = withStyles((theme) => ({
	root:
	{
		margin   : 0,
		padding  : theme.spacing(1)
	}
}))(MuiDialogTitle);

const DialogContent = withStyles((theme) => ({
	root:
	{
		padding: theme.spacing(2, 1)
	}
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
	root:
	{
		margin: 0,
		padding: theme.spacing(1),
		justifyContent:'space-between'
	}
}))(MuiDialogActions);

const LoginDialog = ({
	roomClient,
	room,
	mediaPerms,
	classes,
	userInfo,
	resolution,
	setUserInfo,
	setLoggedIn,
	setConfId,
	setJoinError,
	setMediaPerms,
	lang,
	localesList,
	setSubtitleEnable,
	setRecordingPromptEnable
}) => {

	const intl = useIntl();
	const history = useHistory();

	const _askForPerms = async () => {

		let _constraints = { audio: true };
		Object.assign(_constraints, { video: window.config.VIDEO_CONSTRAINS[resolution] });
		try {
			const stream = await navigator.mediaDevices.getUserMedia(_constraints);
			// 关闭 stream
			stream.getTracks().forEach(track => track.stop());
		} catch (e) {
			logger.error('_askForPerms 出错:%o', e);
		}
	};

	const [messageTip, setMessageTip] = useState('');               // 提示信息
	const [clickInProgress, setClickInProgress] = useState(false);  // 请求状态
	const [autoLoggingIn, setAutoLoggingIn] = useState(false);      // 自动登录状态

	const { register, handleSubmit, errors } = useForm();

	// 入会前基于参数尝试登录
	useEffect(() => {

		if (userInfo.joinType === 1 && userInfo.autoJoin === 0) {
			// 账号/密码自动登录
			let _roomPwd = '';
			userInfo.confPwd && (_roomPwd = userInfo.confPwd);

			/**
			 * 加载组件时尝试自动登录
			 * @param {账号} username
			 * @param {密码} password
			 */
			const _autoJoining = async (username, password) => {

				setAutoLoggingIn(true);
				const _data = { username, password };
				const _loginUserInfo = await wrapperAxios.post('/user/login', _data);

				logger.debug('帐号/密码自动登录 [参数:%o , 结果: %o]', _data, _loginUserInfo);

				// 清理水印
				window.sessionStorage.removeItem('watermark');

				if (_loginUserInfo.isSuccess && _loginUserInfo.code === '200') {

					const _userInfo = { 
						...userInfo, 
						..._loginUserInfo.data, 
						path: 'login' 
					};

					// 设置勾选状态
					if (_userInfo.joinMeeting) {

						setMediaPerms({
							...mediaPerms,
							audio: !Boolean(_userInfo.joinMeeting.micAutoEnable.default),
							video: !Boolean(_userInfo.joinMeeting.camaraAutoEnable.default)
						});

						setSubtitleEnable(_userInfo.joinMeeting.subtitleEnable);
						setRecordingPromptEnable(Boolean(_userInfo.joinMeeting.recordingPromptEnable));
					}

					setUserInfo(_userInfo);
					setLoggedIn(true); // 设为已登录状态

					if (userInfo.confId) {

						setConfId(userInfo.confId);  // 设置会议室号
						await _askForPerms();
						// 登录
						await roomClient.join({
							roomId     : encodeURIComponent(userInfo.confId),
							joinVideo  : mediaPerms.video,
							joinAudio  : mediaPerms.audio,
							joinToken  : _loginUserInfo.data.token,
							roomPwd    : _roomPwd,
							joinType   : userInfo.joinType
						});
					} else {

						setUserInfo({ 
							..._userInfo, 
							autoJoin: -1 
						});
						// 跳转至会议号输入界面(要求输入房间号)
						history.push({
							pathname: '/choose',
							params: {
								confIdRequired  : true
							}
						});
					}
				} else {

					setUserInfo({ ...userInfo, autoJoin: -1 });
					setAutoLoggingIn(false);

					// 提示错误信息
					const _errCode = parseInt(_loginUserInfo.errorCode);
					const _errMsg = getErrMesage(_errCode, lang);
					logger.debug('账号/密码自动登录错误信息:', _errMsg);

					setMessageTip(_errMsg);
				}
			}

			_autoJoining(userInfo.username, userInfo.password);

		} else if ([undefined, 0].includes(userInfo.joinType)) {
			// 初始化登录状态
			setUserInfo({ ...userInfo, joinType: 1 });
		}
	}, []);

	// 服务端校验(登录入功,入会失败)
	useEffect(() => {

		if (room.joinError && room.joinError.hasError) {

			setAutoLoggingIn(false);

			const _errCode = parseInt(room.joinError.errorCode);
			const _errMsg = getErrMesage(_errCode, lang);

			logger.debug('账号/密码入会错误信息:', _errMsg);

			if (_errCode === 0x20403) {
				history.push({
					pathname: '/choose',
					params: {
						confIdRequired  : false,
						confPwdRequired : true
					}
				});
			} else if (_errCode === 0x20400) {
				history.push({
					pathname: '/choose'
				});
			} else {
				//立即执行, 只执行一次
				const _immediate = setImmediate(() => {

					setMessageTip(_errMsg);
					//移除
					clearImmediate(_immediate);
				});
			}
		}
	}, [room.joinError])

	// 客户端校验
	useEffect(() => {

		if (errors.username) {

			setMessageTip(intl.formatMessage({
				id             : 'feedback.username',
				defaultMessage : 'User name cannot be empty'
			}));

			logger.debug('messageTip: ', messageTip);
		} else if (errors.password) {

			setMessageTip(intl.formatMessage({
				id             : 'feedback.password',
				defaultMessage : 'Password cannot be empty'
			}));
		}
	}, [errors]);

	const handleLogin = async data => {

		logger.debug('handleLogin()', data, errors);

		setClickInProgress(true);

		const _loginUserInfo = await wrapperAxios.post('/user/login', data);

		// 清理水印
		window.sessionStorage.removeItem('watermark');

		if (_loginUserInfo.isSuccess && _loginUserInfo.code == 200) {

			const _userInfo = { 
				...userInfo, 
				..._loginUserInfo.data, 
				path: 'login' 
			};

			setUserInfo(_userInfo);

			// 设置勾选状态
			if (_userInfo.joinMeeting) {

				setMediaPerms({
					...mediaPerms,
					audio: !Boolean(_userInfo.joinMeeting.micAutoEnable.default),
					video: !Boolean(_userInfo.joinMeeting.camaraAutoEnable.default)
				});

				setSubtitleEnable(_userInfo.joinMeeting.subtitleEnable);
				setRecordingPromptEnable(Boolean(_userInfo.joinMeeting.recordingPromptEnable));
			}

			setLoggedIn(true);
			// 清空历史错误
			setJoinError({ 
				hasError: false, 
				errorCode: '' 
			});
			// 跳转至会议号输入界面
			history.push({
				pathname: '/choose'
			});
		} else {

			const _errCode = parseInt(_loginUserInfo.errorCode);
			// 提示错误信息
			const _errMsg = getErrMesage(_errCode, lang);
			logger.debug('账号/密码登录错误信息:', _errMsg);
			setMessageTip(_errMsg);
		}
		setClickInProgress(false);
	}

	return (
		<div className={classes.root}>
			{(autoLoggingIn) ?  <ReactLoading type='bars'/> : <Dialog
				open
				classes={{
					paper: classes.dialogPaper,
					root: classes.dialogRoot
				}}
			>
				<DialogTitle>

					<Grid
						container
						direction='row'
						justify='space-between'
						alignItems='center'
					>
						<Grid item>
							{ window.config.logo ? <img alt='Logo' src={window.config.logo} /> : <Typography variant='h5'> {window.config.title} </Typography> }
						</Grid>

						{window.config.showLangSwitch && <Grid item>
							<Grid
								container
								direction='row'
								justify='flex-end'
								alignItems='center'
							>

								{/* LOCALE SELECTOR */}
								<Grid item>

									<Grid container direction='column' alignItems='center'>
										<Grid item>
											<TextField
												select
												className={classes.locale}
												onChange={(event) => {

													const _lang = event.target.value;
													logger.debug(`选择了 [${_lang}] 语言`);

													roomClient.setLocale(_lang);

												} }
												SelectProps={{
													native: true,
												}}
												defaultValue={lang}
												variant="outlined"
											>
												{localesList.map((option) => (
													<option key={option.locale[0]} value={option.locale[0]}>
														{option.name}
													</option>
												))}
											</TextField>

										</Grid>
									</Grid>

								</Grid>
								{/* /LOCALE SELECTOR */}
							</Grid>
						</Grid>}
					</Grid>

				</DialogTitle>

				<form onSubmit={handleSubmit(handleLogin)}>
					<DialogContent>
						<TextField
							defaultValue={userInfo && userInfo.account}
							autoFocus
							id='username'
							label={intl.formatMessage({
								id: 'label.username',
								defaultMessage: 'Username'
							})}
							variant='outlined'
							margin='normal'
							name='username'
							fullWidth
							inputRef={register({
								required: true
							})}
							error={Boolean(errors.username)}
							inputProps={{
								maxLength: 48,
							}}
							onFocus={(event) => {
								setMessageTip('')
							}}
						/>
						<TextField
							id='password'
							label={intl.formatMessage({
								id: 'label.password',
								defaultMessage: 'Password'
							})}
							defaultValue={userInfo.password}
							variant='outlined'
							margin='normal'
							name='password'
							type='password'
							autoComplete=''
							fullWidth
							inputRef={register({
								required: true,
							})}
							error={Boolean(errors.password)}
							inputProps={{
								maxLength: 24,
							}}
							onFocus={(event) => {
								setMessageTip('')
							}}
						/>
						{messageTip &&
							<DialogContentText className={classes.red} variant='body2' gutterBottom>
								{messageTip}
							</DialogContentText>}
					</DialogContent>
					<DialogActions>
						<div className={classes.version}>v {edition.version.substring(0, edition.version.length - 4) + (window.config.versionSuffix ? window.config.versionSuffix : '')}</div>
						<Button
							disabled={clickInProgress}
							variant='contained'
							color='secondary'
							type='submit'
						>
							<FormattedMessage
								id='label.login'
								defaultMessage='Login'
							/>
						</Button>
					</DialogActions>
				</form>

				{!isElectron() &&
					<CookieConsent buttonText={intl.formatMessage({
						id: 'room.consentUnderstand',
						defaultMessage: 'I understand'
					})}
					>
						<FormattedMessage
							id='room.cookieConsent'
							defaultMessage='This website uses cookies to enhance the user experience'
						/>
					</CookieConsent>
				}
			</Dialog>}
		</div>
	);
};

LoginDialog.propTypes =
{
	roomClient        : PropTypes.any.isRequired,
	room              : PropTypes.object.isRequired,
	classes           : PropTypes.object.isRequired,
	setConfId         : PropTypes.func.isRequired,
	mediaPerms        : PropTypes.object.isRequired,
	resolution        : PropTypes.string.isRequired,
	setJoinError      : PropTypes.func.isRequired,
	userInfo          : PropTypes.object.isRequired,
	setUserInfo       : PropTypes.func.isRequired,
	setLoggedIn       : PropTypes.func.isRequired,
	lang              : PropTypes.string.isRequired,
	localesList       : PropTypes.array.isRequired,
	setSubtitleEnable : PropTypes.func.isRequired,
	setRecordingPromptEnable : PropTypes.func.isRequired
};

const mapStateToProps = (state) =>
{
	return {
		room           : state.room,
		mediaPerms     : state.settings.mediaPerms,
		resolution     : state.settings.resolution,
		userInfo       : state.me.userInfo,
		lang           : state.intl.lang,
		localesList    : state.intl.list
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setUserInfo: (userInfo) => {
			dispatch(meActions.setUserInfo(userInfo));
		},
		setLoggedIn: (flag) => {
			dispatch(meActions.setLoggedIn(flag));
		},
		setConfId: (confId) => {
			dispatch(roomActions.setConfId(confId));
		},
		setJoinError: (errorInfo) => {
			dispatch(roomActions.setJoinError(errorInfo));
		},
		setMediaPerms : (mediaPerms) =>
		{
			dispatch(settingsActions.setMediaPerms(mediaPerms));
		},
		setSubtitleEnable : (flag) =>
		{
			dispatch(roomActions.setSubtitleEnable(flag));
		},
		setRecordingPromptEnable : (flag) =>
		{
			dispatch(roomActions.setRecordingPromptEnable(flag));
		}
	};
};

export default withRoomContext(connect(
	mapStateToProps,
	mapDispatchToProps,
	null,
	{
		areStatesEqual: (next, prev) => {
			return (
				prev.room  === next.room &&
				prev.me.userInfo === next.me.userInfo &&
				prev.settings.mediaPerms === next.settings.mediaPerms &&
				prev.intl.lang === next.intl.lang &&
				prev.intl.localesList === next.intl.localesList
			);
		}
	}
)(withStyles(styles)(LoginDialog)));


